import {Admin} from "./Admin/Admin";
import {Client} from "./Client/Client";

export const ModuloSeatsAPI = {
    Admin: Admin,
    Client: Client
}